import { EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared'

import { type TSortingFlag } from './Mode'

interface IProps {
    flag: TSortingFlag

    arrowWrapperStyle: string
    arrowStyle: string
}

export const SortingButton = (props: IProps) => {
    const { flag, arrowStyle, arrowWrapperStyle } = props
    switch (flag) {
        case 'up':
            return (
                <div className={arrowWrapperStyle}>
                    <span>Новые</span>
                    <div>
                        <Icon iconName={EIcons.AROW} color='#fff' />
                    </div>
                </div>
            )
        case 'down':
            return (
                <div className={arrowWrapperStyle}>
                    <span>Старые </span>
                    <div className={arrowStyle}>
                        <Icon iconName={EIcons.AROW} color='#fff' />
                    </div>
                </div>
            )
        default:
            return <div>По дате</div>
    }
}
